import React from 'react';

interface TitleProps {
  title: string;
}

export const Title: React.FC<TitleProps> = ({ title }) => (
  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
    <h2 className="text-white text-xl font-semibold">{title}</h2>
  </div>
); 